@if (showFooter$ | async) {
  @if (minimalistFooter$ | async) {
    <bgo-minimal-footer
      [showLegalLinks]="showLegalLinks"
      [showProSignUp]="showProSignUp"
      [noFooterMargin]="!!(noFooterMargin$ | async)"
    ></bgo-minimal-footer>
  } @else {
    <bgo-full-footer [showLegalLinks]="showLegalLinks" [showProSignUp]="showProSignUp"></bgo-full-footer>
  }
}
